export default {
  title: 'Прочее'
}
